/**
 * Trigger predicate for the one-time review-app prompt (specs/review-prompt).
 * Guards run cheap-first; the (async) storage read only happens once every
 * synchronous condition has passed. Kept moment-agnostic so a future trigger
 * (e.g. a 1v1 arena win) can reuse it after the World Cup ends.
 */

export interface ReviewPromptTriggerInput {
  /** Platform.OS at the call site — the prompt is native-only. */
  platformOS: string;
  /** The moment that just finished was a win for the user. */
  isWin: boolean;
  /** No further result overlays are queued — never stack the prompt over one. */
  queueEmptyAfterDismiss: boolean;
  /** Deferred storage read: only awaited after all sync guards pass. */
  hasSeen: () => Promise<boolean>;
}

export async function shouldShowReviewPrompt(input: ReviewPromptTriggerInput): Promise<boolean> {
  if (input.platformOS === 'web') return false;
  if (!input.isWin) return false;
  if (!input.queueEmptyAfterDismiss) return false;
  return !(await input.hasSeen());
}
